import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface Props {
  width: number | string;
  height: number | string;
}

const BarsChartSkeleton = ({ width, height }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      <Skeleton
        variant="rectangular"
        width={width}
        height={height}
        animation="pulse"
      />
    </Box>
  );
};

export default BarsChartSkeleton;
